'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dGlobals$0024 from "./presto.-Globals$.js";
import * as $j_presto$002etypes$0024$002dCredential$002dKind$0024 from "./presto.types$-Credential-Kind$.js";
import * as $j_presto$002etypes$0024$002dDoc$002dSigner$0024 from "./presto.types$-Doc-Signer$.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dKind$0024 from "./presto.types$-Grouping-Kind$.js";
import * as $j_presto$002etypes$0024$002dSite$002dRealm$0024 from "./presto.types$-Site-Realm$.js";
import * as $j_presto$002etypes$0024$002dSite$002dSystem$0024 from "./presto.types$-Site-System$.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dType$0024$0024anon$0024151 from "./presto.types$-Two-Factor-Auth-Type$$anon$151.js";
var $p;
/** @constructor */
function $c_Lpresto_types$() {
  this.c1q = null;
  $n_Lpresto_types$ = this;
  this.c1q = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Ljava_time_format_DateTimeFormatter$().ael("dd/MM/YYYY HH:mm:ss");
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Ljava_time_format_DateTimeFormatter$().ael("HH:mm:ss");
}
export { $c_Lpresto_types$ as $c_Lpresto_types$ };
$p = $c_Lpresto_types$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$;
/** @constructor */
function $h_Lpresto_types$() {
}
export { $h_Lpresto_types$ as $h_Lpresto_types$ };
$h_Lpresto_types$.prototype = $p;
$p.cql = (function(dayOfWeek) {
  var x = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$s_Ljava_time_DayOfWeek$__MONDAY__Ljava_time_DayOfWeek();
  if ((x === dayOfWeek)) {
    return "Segunda-Feira";
  }
  var x$3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$s_Ljava_time_DayOfWeek$__TUESDAY__Ljava_time_DayOfWeek();
  if ((x$3 === dayOfWeek)) {
    return "Ter\u00e7a-feira";
  }
  var x$5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$s_Ljava_time_DayOfWeek$__WEDNESDAY__Ljava_time_DayOfWeek();
  if ((x$5 === dayOfWeek)) {
    return "Quarta-feira";
  }
  var x$7 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$s_Ljava_time_DayOfWeek$__THURSDAY__Ljava_time_DayOfWeek();
  if ((x$7 === dayOfWeek)) {
    return "Quinta-feira";
  }
  var x$9 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$s_Ljava_time_DayOfWeek$__FRIDAY__Ljava_time_DayOfWeek();
  if ((x$9 === dayOfWeek)) {
    return "Sexta-feira";
  }
  var x$11 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$s_Ljava_time_DayOfWeek$__SATURDAY__Ljava_time_DayOfWeek();
  if ((x$11 === dayOfWeek)) {
    return "S\u00e1bado";
  }
  var x$13 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$s_Ljava_time_DayOfWeek$__SUNDAY__Ljava_time_DayOfWeek();
  if ((x$13 === dayOfWeek)) {
    return "Domingo";
  }
  throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_MatchError(dayOfWeek);
});
$p.fF = (function(ldt) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Ljava_time_chrono_ChronoLocalDateTime.prototype.cEL.call(ldt, this.c1q);
});
$p.a2L = (function(grouping) {
  var this$1 = grouping.DU;
  var b = $j_presto$002e$002dGlobals$0024.$m_Lpresto_Globals$().a7X;
  return ((this$1.e === b.e) && (this$1.f === b.f));
});
$p.vc = (function(domain) {
  var this$1 = domain.DW;
  var b = $j_presto$002e$002dGlobals$0024.$m_Lpresto_Globals$().a7X;
  return ((this$1.e === b.e) && (this$1.f === b.f));
});
$p.cCY = (function(eml) {
  var idx = (eml.indexOf("@") | 0);
  var beginIndex = ((1 + idx) | 0);
  return eml.substring(beginIndex);
});
$p.cJp = (function(d, str) {
  return (d === str);
});
$p.acH = (function(it) {
  var x = $s_Lpresto_types$TwoFactorAuthType$__SeedTimeBased__Lpresto_types$TwoFactorAuthType();
  if ((x === it)) {
    return "Token Baseado em Tempo";
  }
  var x$3 = $s_Lpresto_types$TwoFactorAuthType$__Email__Lpresto_types$TwoFactorAuthType();
  if ((x$3 === it)) {
    return "Email";
  }
  throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_MatchError(it);
});
$p.uU = (function(it) {
  var x = $j_presto$002etypes$0024$002dCredential$002dKind$0024.$s_Lpresto_types$CredentialKind$__a3__Lpresto_types$CredentialKind();
  if ((x === it)) {
    return "A3 F\u00edsico";
  }
  var x$3 = $j_presto$002etypes$0024$002dCredential$002dKind$0024.$s_Lpresto_types$CredentialKind$__up__Lpresto_types$CredentialKind();
  if ((x$3 === it)) {
    return "Usu\u00e1rio e senha";
  }
  var x$5 = $j_presto$002etypes$0024$002dCredential$002dKind$0024.$s_Lpresto_types$CredentialKind$__cp__Lpresto_types$CredentialKind();
  if ((x$5 === it)) {
    return "Certificado e PIN";
  }
  var x$7 = $j_presto$002etypes$0024$002dCredential$002dKind$0024.$s_Lpresto_types$CredentialKind$__upcp__Lpresto_types$CredentialKind();
  if ((x$7 === it)) {
    return "Usu\u00e1rio, senha, certificado e PIN";
  }
  var x$9 = $j_presto$002etypes$0024$002dCredential$002dKind$0024.$s_Lpresto_types$CredentialKind$__smartpass__Lpresto_types$CredentialKind();
  if ((x$9 === it)) {
    return "SmartPass";
  }
  throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_MatchError(it);
});
$p.cE8 = (function(it) {
  var x = $j_presto$002etypes$0024$002dGrouping$002dKind$0024.$s_Lpresto_types$GroupingKind$__intimacao__Lpresto_types$GroupingKind();
  if ((x === it)) {
    return "Intima\u00e7\u00e3o";
  }
  var x$3 = $j_presto$002etypes$0024$002dGrouping$002dKind$0024.$s_Lpresto_types$GroupingKind$__movimentacao__Lpresto_types$GroupingKind();
  if ((x$3 === it)) {
    return "Movimenta\u00e7\u00e3o";
  }
  var x$5 = $j_presto$002etypes$0024$002dGrouping$002dKind$0024.$s_Lpresto_types$GroupingKind$__protocolo__Lpresto_types$GroupingKind();
  if ((x$5 === it)) {
    return "Protocolo";
  }
  var x$7 = $j_presto$002etypes$0024$002dGrouping$002dKind$0024.$s_Lpresto_types$GroupingKind$__copia__Lpresto_types$GroupingKind();
  if ((x$7 === it)) {
    return "C\u00f3pia Integral";
  }
  throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_MatchError(it);
});
$p.z4 = (function(it) {
  var x = $j_presto$002etypes$0024$002dSite$002dRealm$0024.$s_Lpresto_types$SiteRealm$__administrativo__Lpresto_types$SiteRealm();
  if ((x === it)) {
    return "Administrativo";
  }
  var x$3 = $j_presto$002etypes$0024$002dSite$002dRealm$0024.$s_Lpresto_types$SiteRealm$__eleitoral__Lpresto_types$SiteRealm();
  if ((x$3 === it)) {
    return "Eleitoral";
  }
  var x$5 = $j_presto$002etypes$0024$002dSite$002dRealm$0024.$s_Lpresto_types$SiteRealm$__judicial__Lpresto_types$SiteRealm();
  if ((x$5 === it)) {
    return "Judicial";
  }
  var x$7 = $j_presto$002etypes$0024$002dSite$002dRealm$0024.$s_Lpresto_types$SiteRealm$__estadual__Lpresto_types$SiteRealm();
  if ((x$7 === it)) {
    return "Estadual";
  }
  var x$9 = $j_presto$002etypes$0024$002dSite$002dRealm$0024.$s_Lpresto_types$SiteRealm$__federal__Lpresto_types$SiteRealm();
  if ((x$9 === it)) {
    return "Federal";
  }
  var x$11 = $j_presto$002etypes$0024$002dSite$002dRealm$0024.$s_Lpresto_types$SiteRealm$__militar__Lpresto_types$SiteRealm();
  if ((x$11 === it)) {
    return "Militar";
  }
  var x$13 = $j_presto$002etypes$0024$002dSite$002dRealm$0024.$s_Lpresto_types$SiteRealm$__trabalhista__Lpresto_types$SiteRealm();
  if ((x$13 === it)) {
    return "Trabalhista";
  }
  throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_MatchError(it);
});
$p.ld = (function(it) {
  var x = $j_presto$002etypes$0024$002dSite$002dSystem$0024.$s_Lpresto_types$SiteSystem$__undef__Lpresto_types$SiteSystem();
  if ((x === it)) {
    return "Outros";
  }
  var x$3 = $j_presto$002etypes$0024$002dSite$002dSystem$0024.$s_Lpresto_types$SiteSystem$__benner__Lpresto_types$SiteSystem();
  if ((x$3 === it)) {
    return "Benner";
  }
  var x$5 = $j_presto$002etypes$0024$002dSite$002dSystem$0024.$s_Lpresto_types$SiteSystem$__eproc__Lpresto_types$SiteSystem();
  if ((x$5 === it)) {
    return "Eproc";
  }
  var x$7 = $j_presto$002etypes$0024$002dSite$002dSystem$0024.$s_Lpresto_types$SiteSystem$__esaj__Lpresto_types$SiteSystem();
  if ((x$7 === it)) {
    return "e-SAJ";
  }
  var x$9 = $j_presto$002etypes$0024$002dSite$002dSystem$0024.$s_Lpresto_types$SiteSystem$__exyon__Lpresto_types$SiteSystem();
  if ((x$9 === it)) {
    return "e-xyon";
  }
  var x$11 = $j_presto$002etypes$0024$002dSite$002dSystem$0024.$s_Lpresto_types$SiteSystem$__govbr__Lpresto_types$SiteSystem();
  if ((x$11 === it)) {
    return "Gov.br";
  }
  var x$13 = $j_presto$002etypes$0024$002dSite$002dSystem$0024.$s_Lpresto_types$SiteSystem$__jpe__Lpresto_types$SiteSystem();
  if ((x$13 === it)) {
    return "JPe";
  }
  var x$15 = $j_presto$002etypes$0024$002dSite$002dSystem$0024.$s_Lpresto_types$SiteSystem$__microsoft__Lpresto_types$SiteSystem();
  if ((x$15 === it)) {
    return "Microsoft";
  }
  var x$17 = $j_presto$002etypes$0024$002dSite$002dSystem$0024.$s_Lpresto_types$SiteSystem$__oystr__Lpresto_types$SiteSystem();
  if ((x$17 === it)) {
    return "Oystr";
  }
  var x$19 = $j_presto$002etypes$0024$002dSite$002dSystem$0024.$s_Lpresto_types$SiteSystem$__pdpj__Lpresto_types$SiteSystem();
  if ((x$19 === it)) {
    return "PDPJ";
  }
  var x$21 = $j_presto$002etypes$0024$002dSite$002dSystem$0024.$s_Lpresto_types$SiteSystem$__pje__Lpresto_types$SiteSystem();
  if ((x$21 === it)) {
    return "PJe";
  }
  var x$23 = $j_presto$002etypes$0024$002dSite$002dSystem$0024.$s_Lpresto_types$SiteSystem$__proprio__Lpresto_types$SiteSystem();
  if ((x$23 === it)) {
    return "Pr\u00f3prio";
  }
  var x$25 = $j_presto$002etypes$0024$002dSite$002dSystem$0024.$s_Lpresto_types$SiteSystem$__projudi__Lpresto_types$SiteSystem();
  if ((x$25 === it)) {
    return "Projudi";
  }
  var x$27 = $j_presto$002etypes$0024$002dSite$002dSystem$0024.$s_Lpresto_types$SiteSystem$__tucujuris__Lpresto_types$SiteSystem();
  if ((x$27 === it)) {
    return "Tucujuris";
  }
  throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_MatchError(it);
});
$p.cE7 = (function(it) {
  var x = $j_presto$002etypes$0024$002dDoc$002dSigner$0024.$s_Lpresto_types$DocSigner$__cms__Lpresto_types$DocSigner();
  if ((x === it)) {
    return "Java (cms)";
  }
  var x$3 = $j_presto$002etypes$0024$002dDoc$002dSigner$0024.$s_Lpresto_types$DocSigner$__pje__Lpresto_types$DocSigner();
  if ((x$3 === it)) {
    return "Java (pje)";
  }
  var x$5 = $j_presto$002etypes$0024$002dDoc$002dSigner$0024.$s_Lpresto_types$DocSigner$__pkie__Lpresto_types$DocSigner();
  if ((x$5 === it)) {
    return "Pkie";
  }
  var x$7 = $j_presto$002etypes$0024$002dDoc$002dSigner$0024.$s_Lpresto_types$DocSigner$__bry__Lpresto_types$DocSigner();
  if ((x$7 === it)) {
    return "BRy";
  }
  var x$9 = $j_presto$002etypes$0024$002dDoc$002dSigner$0024.$s_Lpresto_types$DocSigner$__serpro__Lpresto_types$DocSigner();
  if ((x$9 === it)) {
    return "Serpro";
  }
  var x$11 = $j_presto$002etypes$0024$002dDoc$002dSigner$0024.$s_Lpresto_types$DocSigner$__shodo__Lpresto_types$DocSigner();
  if ((x$11 === it)) {
    return "Shod\u014d";
  }
  throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_MatchError(it);
});
$p.uT = (function(it) {
  if ((it === true)) {
    return "Sim";
  }
  if ((it === false)) {
    return "N\u00e3o";
  }
  throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_MatchError(it);
});
var $d_Lpresto_types$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$, "presto.types$", ({
  Yn: 1
}));
export { $d_Lpresto_types$ as $d_Lpresto_types$ };
var $n_Lpresto_types$;
function $m_Lpresto_types$() {
  if ((!$n_Lpresto_types$)) {
    $n_Lpresto_types$ = new $c_Lpresto_types$();
  }
  return $n_Lpresto_types$;
}
export { $m_Lpresto_types$ as $m_Lpresto_types$ };
/** @constructor */
function $c_Lpresto_types$TwoFactorAuthType$$anon$153(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$TwoFactorAuthType$$anon$153 as $c_Lpresto_types$TwoFactorAuthType$$anon$153 };
$p = $c_Lpresto_types$TwoFactorAuthType$$anon$153.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TwoFactorAuthType$$anon$153;
/** @constructor */
function $h_Lpresto_types$TwoFactorAuthType$$anon$153() {
}
export { $h_Lpresto_types$TwoFactorAuthType$$anon$153 as $h_Lpresto_types$TwoFactorAuthType$$anon$153 };
$h_Lpresto_types$TwoFactorAuthType$$anon$153.prototype = $p;
$p.bN = (function(text) {
  try {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success($m_Lpresto_types$TwoFactorAuthType$().cw7(text));
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().ak(e$2)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
    }
  }
});
$p.cAs = (function(it) {
  try {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(it.l());
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().ak(e$2)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
    }
  }
});
$p.bJ = (function(t) {
  return this.cAs(t);
});
var $d_Lpresto_types$TwoFactorAuthType$$anon$153 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TwoFactorAuthType$$anon$153, "presto.types$TwoFactorAuthType$$anon$153", ({
  a2R: 1,
  K: 1
}));
export { $d_Lpresto_types$TwoFactorAuthType$$anon$153 as $d_Lpresto_types$TwoFactorAuthType$$anon$153 };
function $s_Lpresto_types$TwoFactorAuthType$__Error__Lpresto_types$TwoFactorAuthType() {
  $m_Lpresto_types$TwoFactorAuthType$();
  return $t_Lpresto_types$TwoFactorAuthType$__Error;
}
export { $s_Lpresto_types$TwoFactorAuthType$__Error__Lpresto_types$TwoFactorAuthType as $s_Lpresto_types$TwoFactorAuthType$__Error__Lpresto_types$TwoFactorAuthType };
function $s_Lpresto_types$TwoFactorAuthType$__SeedTimeBased__Lpresto_types$TwoFactorAuthType() {
  $m_Lpresto_types$TwoFactorAuthType$();
  return $t_Lpresto_types$TwoFactorAuthType$__SeedTimeBased;
}
export { $s_Lpresto_types$TwoFactorAuthType$__SeedTimeBased__Lpresto_types$TwoFactorAuthType as $s_Lpresto_types$TwoFactorAuthType$__SeedTimeBased__Lpresto_types$TwoFactorAuthType };
function $s_Lpresto_types$TwoFactorAuthType$__Email__Lpresto_types$TwoFactorAuthType() {
  $m_Lpresto_types$TwoFactorAuthType$();
  return $t_Lpresto_types$TwoFactorAuthType$__Email;
}
export { $s_Lpresto_types$TwoFactorAuthType$__Email__Lpresto_types$TwoFactorAuthType as $s_Lpresto_types$TwoFactorAuthType$__Email__Lpresto_types$TwoFactorAuthType };
/** @constructor */
function $c_Lpresto_types$TwoFactorAuthType$() {
  this.ccw = null;
  this.ccx = false;
  this.ccu = null;
  this.ccv = false;
  this.ccy = null;
  this.ccz = false;
  this.a9F = null;
  $n_Lpresto_types$TwoFactorAuthType$ = this;
  $t_Lpresto_types$TwoFactorAuthType$__Error = new $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dType$0024$0024anon$0024151.$c_Lpresto_types$TwoFactorAuthType$$anon$151(0, "Error", this);
  $t_Lpresto_types$TwoFactorAuthType$__SeedTimeBased = new $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dType$0024$0024anon$0024151.$c_Lpresto_types$TwoFactorAuthType$$anon$151(1, "SeedTimeBased", this);
  $t_Lpresto_types$TwoFactorAuthType$__Email = new $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dType$0024$0024anon$0024151.$c_Lpresto_types$TwoFactorAuthType$$anon$151(2, "Email", this);
  $s_Lpresto_types$TwoFactorAuthType$__Error__Lpresto_types$TwoFactorAuthType();
  $s_Lpresto_types$TwoFactorAuthType$__SeedTimeBased__Lpresto_types$TwoFactorAuthType();
  $s_Lpresto_types$TwoFactorAuthType$__Email__Lpresto_types$TwoFactorAuthType();
  this.a9F = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Map$().ba($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().c(new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_T2.r().C)([new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2($s_Lpresto_types$TwoFactorAuthType$__SeedTimeBased__Lpresto_types$TwoFactorAuthType(), $m_Lpresto_types$().acH($s_Lpresto_types$TwoFactorAuthType$__SeedTimeBased__Lpresto_types$TwoFactorAuthType())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2($s_Lpresto_types$TwoFactorAuthType$__Email__Lpresto_types$TwoFactorAuthType(), $m_Lpresto_types$().acH($s_Lpresto_types$TwoFactorAuthType$__Email__Lpresto_types$TwoFactorAuthType()))])));
}
export { $c_Lpresto_types$TwoFactorAuthType$ as $c_Lpresto_types$TwoFactorAuthType$ };
$p = $c_Lpresto_types$TwoFactorAuthType$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TwoFactorAuthType$;
/** @constructor */
function $h_Lpresto_types$TwoFactorAuthType$() {
}
export { $h_Lpresto_types$TwoFactorAuthType$ as $h_Lpresto_types$TwoFactorAuthType$ };
$h_Lpresto_types$TwoFactorAuthType$.prototype = $p;
$p.cw7 = (function(\u03b4name) {
  switch (\u03b4name) {
    case "Error": {
      return $s_Lpresto_types$TwoFactorAuthType$__Error__Lpresto_types$TwoFactorAuthType();
      break;
    }
    case "SeedTimeBased": {
      return $s_Lpresto_types$TwoFactorAuthType$__SeedTimeBased__Lpresto_types$TwoFactorAuthType();
      break;
    }
    case "Email": {
      return $s_Lpresto_types$TwoFactorAuthType$__Email__Lpresto_types$TwoFactorAuthType();
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IllegalArgumentException(), ("enum case not found: " + \u03b4name));
    }
  }
});
$p.adn = (function() {
  if ((!this.ccx)) {
    this.ccw = new $c_Lpresto_types$TwoFactorAuthType$$anon$152(this);
    this.ccx = true;
  }
  return this.ccw;
});
$p.zj = (function() {
  if ((!this.ccv)) {
    this.ccu = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$14(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((str) => {
      try {
        return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success($m_Lpresto_types$TwoFactorAuthType$().cw7(str));
      } catch (e) {
        var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
        if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().ak(e$2)) {
          return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
        } else {
          throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
        }
      }
    })), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8);
    this.ccv = true;
  }
  return this.ccu;
});
$p.a2E = (function() {
  if ((!this.ccz)) {
    this.ccy = new $c_Lpresto_types$TwoFactorAuthType$$anon$153(this);
    this.ccz = true;
  }
  return this.ccy;
});
var $d_Lpresto_types$TwoFactorAuthType$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TwoFactorAuthType$, "presto.types$TwoFactorAuthType$", ({
  a2O: 1,
  e: 1,
  H: 1
}));
export { $d_Lpresto_types$TwoFactorAuthType$ as $d_Lpresto_types$TwoFactorAuthType$ };
var $n_Lpresto_types$TwoFactorAuthType$;
function $m_Lpresto_types$TwoFactorAuthType$() {
  if ((!$n_Lpresto_types$TwoFactorAuthType$)) {
    $n_Lpresto_types$TwoFactorAuthType$ = new $c_Lpresto_types$TwoFactorAuthType$();
  }
  return $n_Lpresto_types$TwoFactorAuthType$;
}
export { $m_Lpresto_types$TwoFactorAuthType$ as $m_Lpresto_types$TwoFactorAuthType$ };
/** @constructor */
function $c_Lpresto_types$TwoFactorAuthType$$anon$152(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$TwoFactorAuthType$$anon$152 as $c_Lpresto_types$TwoFactorAuthType$$anon$152 };
$p = $c_Lpresto_types$TwoFactorAuthType$$anon$152.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TwoFactorAuthType$$anon$152;
/** @constructor */
function $h_Lpresto_types$TwoFactorAuthType$$anon$152() {
}
export { $h_Lpresto_types$TwoFactorAuthType$$anon$152 as $h_Lpresto_types$TwoFactorAuthType$$anon$152 };
$h_Lpresto_types$TwoFactorAuthType$$anon$152.prototype = $p;
$p.a1 = (function(a) {
  $m_Lpresto_types$TwoFactorAuthType$();
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Json$();
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Json$JString(a.l());
});
var $d_Lpresto_types$TwoFactorAuthType$$anon$152 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TwoFactorAuthType$$anon$152, "presto.types$TwoFactorAuthType$$anon$152", ({
  a2Q: 1,
  a: 1,
  j: 1
}));
export { $d_Lpresto_types$TwoFactorAuthType$$anon$152 as $d_Lpresto_types$TwoFactorAuthType$$anon$152 };
var $t_Lpresto_types$TwoFactorAuthType$__Error = null;
function $u_Lpresto_types$TwoFactorAuthType$__Error(x) {
  $t_Lpresto_types$TwoFactorAuthType$__Error = x;
}
export { $t_Lpresto_types$TwoFactorAuthType$__Error as $t_Lpresto_types$TwoFactorAuthType$__Error, $u_Lpresto_types$TwoFactorAuthType$__Error as $u_Lpresto_types$TwoFactorAuthType$__Error };
var $t_Lpresto_types$TwoFactorAuthType$__SeedTimeBased = null;
function $u_Lpresto_types$TwoFactorAuthType$__SeedTimeBased(x) {
  $t_Lpresto_types$TwoFactorAuthType$__SeedTimeBased = x;
}
export { $t_Lpresto_types$TwoFactorAuthType$__SeedTimeBased as $t_Lpresto_types$TwoFactorAuthType$__SeedTimeBased, $u_Lpresto_types$TwoFactorAuthType$__SeedTimeBased as $u_Lpresto_types$TwoFactorAuthType$__SeedTimeBased };
var $t_Lpresto_types$TwoFactorAuthType$__Email = null;
function $u_Lpresto_types$TwoFactorAuthType$__Email(x) {
  $t_Lpresto_types$TwoFactorAuthType$__Email = x;
}
export { $t_Lpresto_types$TwoFactorAuthType$__Email as $t_Lpresto_types$TwoFactorAuthType$__Email, $u_Lpresto_types$TwoFactorAuthType$__Email as $u_Lpresto_types$TwoFactorAuthType$__Email };
//# sourceMappingURL=presto.types$.js.map
